import PuzzleService from '_services/rest/modules/puzzle';
import { handleResourceLoadError } from '_utils';

export default {
  state: {
    numerex: null,
    hasChanges: false,
  },
  mutations: {
    setNumerex(state, numerex) {
      state.numerex = numerex;
    },
    setHasChanges(state, status) {
      state.hasChanges = status;
    },
  },
  actions: {
    setNumerex({ commit }, model) {
      commit('setNumerex', model);
    },
    setHasChanges({ commit }, status) {
      commit('setHasChanges', status);
    },
    getNumerex({ commit, dispatch }, id) {
      return PuzzleService.getPuzzleById(id)
        .then(response => {
          commit('setNumerex', response);
          commit('setHasChanges', false);
        })
        .catch(error => {
          handleResourceLoadError(dispatch, error, 'admin-numerex-list');
        });
    },
  },
};
